import { Button } from '@mui/material';
import { DollarSign } from 'react-feather'

// Imports custom
import { TooltipInformation, CustomTableData, LinearLoading } from 'common'

export const PaymentsTable = ({useFetchInit}) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        //------------- Helpers
        //------------- Formularios
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchPaymentsByContract } = FetchData
    const { dataPayments, loadingFetchPaymentsByContract } = fetchPaymentsByContract

    // ------------------------------------------------ Actions
    const { 
        handleClickOpenTransactionsModal
    } = Actions

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                    //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                    const {usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                    return(
                        <>
                            <TooltipInformation 
                                usuario_creo={usuario_creo}
                                fecha_creo={fecha_creo}
                                usuario_modifico={usuario_modifico}
                                fecha_modifico={fecha_modifico}
                            />
                        </>
                        
                    )
            }
        },
        { 
            field: "info_tipo", 
            headerName: "TIPO", 
            minWidth: 160,
            maxWidth: 160,
            filter: true ,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {
                return params.value === 'ORDINARIO' ? 'bg-info' : 'bg-warning';
            },
            cellRenderer: (params) => {
                const { value } = params
                return(
                    (value ==='ORDINARIO') 
                        ? <span><i className="fa-solid fa-circle-check"></i> ORDINARIO</span>
                        : <span><i className="fa-solid fa-circle-exclamation"></i> EXTRAORDINARIO </span>
                )
            }
        },
        { field: "info_fecha_pago", headerName: "FECHA PAGAR", minWidth: 140, filter: true },
        {
            field: "info_costo_alquiler", headerName: "ALQUILER (Q)", minWidth: 140, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "info_exoneracion", headerName: "EXONERACIÓN (Q)", minWidth: 180, filter: true,
            cellClass: (params) => {
                return parseFloat(params.data.info_exoneracion) !== 0 ? 'bg-secondary bg-gradient text-white' : '';
            },
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "total_cancelar", headerName: "CANCELAR (Q)", minWidth: 150, filter: true,
            cellClass: (params) => {
                return params.data.info_tipo === 'ORDINARIO' ? 'bg-warning' : 'bg-primary';
            },
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        {
            field: "total_recibido", headerName: "RECIBIDO (Q)", minWidth: 140, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "total_saldo", headerName: "SALDO (Q)", minWidth: 140, filter: true,
            cellClass: (params) => {
                return parseFloat(params.value) !== 0 ? 'bg-danger' : 'bg-success';
            },
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        {
            headerName: "OPCIONES",
            minWidth: 350,
            cellRenderer: (params) => {
                const {total_saldo} = params.data
                return(
                    <>
                        <Button 
                            startIcon = { <DollarSign/>}
                            variant='contained'
                            size='small' 
                            sx={{ marginRight: '8px' }}
                            onClick={
                                () => handleClickOpenTransactionsModal(
                                    '',
                                    `REGISTRO DE MOVIMIENTOS, SALDO TOTAL: Q ${parseFloat(total_saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                                    'ModalTransactions', 
                                    { data: params.data },
                                    'EDITABLE'
                                )
                            }
                            style={ { 
                                width: 170,
                                background: (parseFloat(total_saldo) === 0) ? '#7ca2b4' : '#2e7d32'
                            }}
                            disabled={false}
                        >
                            Movimientos
                        </Button>
                    </>
                    
                )
            }
        },
    ]

    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            {(loadingFetchPaymentsByContract)&& (<LinearLoading/>)}
            <CustomTableData 
                // datos (listados, individuales)
                rowConfig={dataPayments}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )
}
